import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

const copy = {
  fr: {
    eyebrow: "SERVICE DE RÉÉMAILLAGE",
    title: "Réémaillage de baignoire et surfaces de salle de bain",
    intro:
      "Éco-Bain restaure les surfaces usées, tachées, égratignées ou jaunies sans démolir la salle de bain. L’intervention est adaptée au matériau et à l’état réel de la surface.",
    sectionTitle: "Surfaces prises en charge",
    services: [
      ["Baignoires", "Réémaillage de baignoires en fonte, en acier émaillé et en acrylique."],
      ["Lavabos et éviers", "Réémaillage de lavabos de salle de bain, éviers de cuisine et cuves de lavage."],
      ["Douches et céramique", "Rénovation de bases de douche, cabines et céramique murale."],
      ["Réparation acrylique", "Réparation locale de fissures et dommages sur baignoires et douches en acrylique."],
    ],
    processTitle: "Une restauration sans remplacement complet",
    process:
      "La surface est nettoyée, préparée, réparée lorsque nécessaire, puis recouverte avec un système adapté. L’intervention complète est réalisée en 90 minutes et la baignoire est utilisable dès le lendemain. L’objectif est de retrouver une surface lisse et uniforme tout en évitant les travaux de démolition et de plomberie associés au remplacement.",
    quote: "Demander un devis gratuit",
  },
  en: {
    eyebrow: "REGLAZING SERVICE",
    title: "Bathtub and bathroom-surface reglazing",
    intro:
      "Éco-Bain restores worn, stained, scratched or yellowed surfaces without demolishing the bathroom. The work is adapted to the material and actual condition of the surface.",
    sectionTitle: "Surfaces we work on",
    services: [
      ["Bathtubs", "Reglazing for cast-iron, enamelled-steel and acrylic bathtubs."],
      ["Sinks and basins", "Reglazing for bathroom sinks, kitchen sinks and laundry tubs."],
      ["Showers and wall tile", "Renovation of shower bases, cabins and wall tile."],
      ["Acrylic repair", "Local repair of cracks and damage on acrylic bathtubs and showers."],
    ],
    processTitle: "Restoration without full replacement",
    process:
      "The surface is cleaned, prepared, repaired when needed and coated with a system suited to the material. The complete intervention takes 90 minutes, and the bathtub is ready to use the next day. The goal is a smooth, uniform finish without the demolition and plumbing work associated with replacement.",
    quote: "Request a free estimate",
  },
};

export default function ServiceReemaillage() {
  const { language } = useLanguage();
  const content = copy[language] || copy.fr;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <section className="bg-gradient-to-b from-slate-50 to-white py-16 text-slate-900 dark:from-[#070b12] dark:to-[#0b1318] dark:text-white sm:py-20">
      <div className="container-width">
        <div className="mx-auto max-w-4xl">
          <p className="text-sm font-semibold tracking-[0.2em] text-[#4d9f48] dark:text-[#66C95E]">
            {content.eyebrow}
          </p>
          <h1 className="mt-4 text-4xl font-bold leading-tight sm:text-5xl">{content.title}</h1>
          <p className="mt-6 max-w-3xl text-lg leading-relaxed text-slate-600 dark:text-slate-300">
            {content.intro}
          </p>

          <h2 className="mt-14 text-3xl font-bold">{content.sectionTitle}</h2>
          <div className="mt-6 grid gap-5 sm:grid-cols-2">
            {content.services.map(([title, description]) => (
              <article key={title} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-white/5">
                <h3 className="text-xl font-semibold">{title}</h3>
                <p className="mt-2 leading-relaxed text-slate-600 dark:text-slate-300">{description}</p>
              </article>
            ))}
          </div>

          <div className="mt-12 rounded-3xl bg-[#0b1c2d] p-7 text-white sm:p-9">
            <h2 className="text-2xl font-bold sm:text-3xl">{content.processTitle}</h2>
            <p className="mt-4 max-w-3xl leading-relaxed text-slate-200">{content.process}</p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a href="/#contact" className="inline-flex min-h-11 items-center justify-center rounded-2xl bg-[#66C95E] px-5 py-3 font-semibold text-white hover:bg-[#58B551]">
                {content.quote}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
